import { Icon } from './Icon';

export function Toast({ message }: { message: string | null }) {
  return <div className={`toast ${message ? 'show' : ''}`} role="status">
    <Icon name="check" /><span>{message}</span>
  </div>;
}
